import { useState } from "react";
import { LoginPageTopBar, TopBarComponent } from "./TopBar";

export function TopBarWrapper() {
    return <TopBarComponent/>
}